import React from 'react';

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmButtonText,
  cancelButtonText,
}) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="justify-center flex items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-full mx-3 my-4 max-w-md">
          <div className="p-4 border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            <button
              className="p-1 ml-auto bg-transparent border-0 text-black text-3xl leading-none font-semibold outline-none focus:outline-none absolute right-1 top-3 z-10 flex justify-center items-center"
              onClick={onClose}
            >
              <span className="bg-transparent text-black w-10 block outline-none focus:outline-none text-lg font-semibold">
                <img
                  src="/img/closebutton.svg"
                  className="inline-block w-6"
                  alt="Close"
                />
              </span>
            </button>

            <h3 className="text-lg font-semibold mb-3">{title}</h3>
            <p className="mb-4 text-lg">{message}</p>

            <div className="flex justify-end items-end md:mb-0 mb-4">
              <div className="flex gap-3">
                <button
                  type="button"
                  className="bg-[#AAAAAA] text-white px-4 py-2 rounded-md"
                  onClick={onClose}
                >
                  {cancelButtonText}
                </button>
                <button
                  type="button"
                  className="bg-GreenColor text-brandBlue text-base font-semibold px-4 py-2 rounded-md"
                  onClick={onConfirm}
                >
                  {confirmButtonText}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
};

export default ConfirmationModal;
